import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Injectable()
export class PrintCreditForm {
    constructor(private formBuilder: FormBuilder) {}

    public buildForm(): FormGroup {
        return this.formBuilder.group({
            product: [null, [Validators.required]],
            status: ['', Validators.required],
        });
    }
}
